<template>
  <section id="contact">
    <v-layout column wrap class="grey lighten-4" align-center>
      <v-flex xs12 sm4 class="my-3 pa-5">
        <div class="text-xs-center">
          <h2 class="headline">お問い合わせ</h2>
          <span class="subheading purple--text">
            Contact
          </span>
        </div>
      </v-flex>
      <v-flex xs12 md12 class="mb-5">
        <v-list column class="layout justify-center">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon class="pink--text text--lighten-2">email</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>happiness.jockey@gmail.com</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs12 md12 class="mb-5">
        <v-list column class="layout justify-center">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon class="pink--text text--lighten-2">phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>080-1299-0524</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
